export default __webpack_public_path__ + "static/media/error.cb6c0bbb.svg";